import { getAll } from "./get-all";

export const ProgramService = {
  getAll
};
